module.exports = __webpack_public_path__ + "static/media/logo.e18edf28.jpg";